<template>
  <Teleport to="#modal">
    <div class="fixed inset-0 h-screen w-screen bg-black z-max">
      <TransitionFade>
        <video v-if="fadeOut" ref="introVideo" :controls="!autoplayEnabled" playsinline
               class="absolute top-1/2 left-1/2 w-full -translate-x-1/2 -translate-y-1/2 lg:h-full lg:object-cover">
          <source :src="videoPrompt" type="video/mp4">
        </video>
      </TransitionFade>
      <XMarkIcon class="absolute top-3 right-3 h-12 w-12 cursor-pointer p-1 text-white opacity-50 hover:opacity-100"
                 @click="$emit('close')"/>
      <TransitionFade>
        <FormButton v-if="fadeIn" size="md" color="white" type="button"
                    class="right-4 bottom-4 opacity-50 hover:opacity-100"
                    style="position: absolute;" @click="$emit('skip')">
          Skip Question
        </FormButton>
      </TransitionFade>
    </div>
  </Teleport>
</template>

<script setup>
import {XMarkIcon} from "@heroicons/vue/20/solid/index.js";
import {onBeforeUnmount, onMounted, ref} from "vue";
import FormButton from "./FormButton.vue";
import TransitionFade from "./TransitionFade.vue";

const emits = defineEmits(["close", "skip", "ended"]);
defineProps({
  videoPrompt: String,
});

const introVideo = ref(null);
const fadeIn = ref(false);
const fadeOut = ref(true);
const autoplayEnabled = ref(true);

const handleFadeIn = () => setTimeout(() => {
  fadeIn.value = true;
}, 500);

const handleEndVideo = () => {
  fadeOut.value = false;
  setTimeout(() => {
    emits("ended");
  }, 500);
};

const attemptAutoplay = async () => {
  try {
    await introVideo.value.play();
    autoplayEnabled.value = true;
  } catch (e) {
    autoplayEnabled.value = false;
    console.info("Autoplay with audio is disabled");
  }
};

onMounted(() => {
  handleFadeIn();
  introVideo.value.addEventListener("ended", handleEndVideo);
  attemptAutoplay();
});

onBeforeUnmount(() => {
  if (introVideo.value) introVideo.value.removeEventListener("ended", handleEndVideo);
});
</script>
